// assets
import { IconHeartRateMonitor, IconAnalyze
} from '@tabler/icons-react';
import {useEffect} from "react";
import axios from "axios";

// constant
const icons = {
  IconHeartRateMonitor, IconAnalyze
};

// ==============================|| UTILITIES MENU ITEMS ||============================== //
async function getMonitorMenus() {
  {
    try {
      const config = {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("token"),
          'Content-Type': 'application/json',
        }
      }
      const response = await axios.get("/api/Monitor", config);

      let monitor = {
        id: 'monitor',
        title: 'Monitor',
        type: 'group',
        children: [
          {
            id: 'monitor_add',
            title: 'Add',
            type: 'item',
            url: '/monitor/add',
            icon: icons.IconHeartRateMonitor,
            breadcrumbs: false
          }
        ]
      };
      for (let item of response.data) {
        monitor.children.push({
          id: 'monitor_' + item.id,
          title: item.title,
          type: 'item',
          url: '/monitor/monitor/' + item.id,
          icon: icons.IconAnalyze,
          breadcrumbs: false
        })
      }
      return monitor
    } catch (error) {
      console.error("Get monitor items failed", error);
    }
  }
}

export default getMonitorMenus;
